/**
 * @desc 获取对私账户信息列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.StaffPaymentInfoResponse>>;
export function request(
  body: defs.basics.StaffPaymentInfoRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getStaffPaymentInfoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
